<template>
  <div
    class="load-spinner"
    :class="{'load-spinner--margin': margin}"
  >
    <div class="load-spinner__spinner"/>
  </div>
</template>

<script>
  export default {
    props: {
      margin: {
        type: Boolean,
        default: true,
      },
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .load-spinner {
    display: flex;
    justify-content: center;
    align-items: center;

    &--margin {
      height: r(64)
    }
  }

  .load-spinner__spinner,
  .load-spinner__spinner:before,
  .load-spinner__spinner:after {
    border-radius: 50%;
    width: r(16);
    height: r(16);
    animation-fill-mode: both;
    animation: load7 1.8s infinite ease-in-out;
  }

  .load-spinner__spinner {
    position: relative;
    transform: translateY(r(-16));
    animation-delay: -0.16s;
  }

  .load-spinner__spinner:before,
  .load-spinner__spinner:after {
    content: '';
    position: absolute;
    top: 0;
  }

  .load-spinner__spinner:before {
    left: r(-24);
    animation-delay: -0.32s;
  }

  .load-spinner__spinner:after {
    left: r(24);
  }

  @keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 r(16) 0 r(-8);
    }
    40% {
      box-shadow: 0 r(16) 0 0;
    }
  }
</style>
